export default __webpack_public_path__ + "static/media/Karolina.13ab8ae0.jpg";